package br.com.texeratx.boardgametimeapp.core.i18n

object EnStrings : Strings {

    // ===== Common =====
    override val back = "Back"
    override val cancel = "Cancel"
    override val delete = "Delete"
    override val edit = "Edit"
    override val save = "Save"
    override val ok = "OK"
    override val loading = "Loading..."
    override val retry = "Try Again"
    override val remove = "Remove"
    override val errorTitle = "Error"
    override val oops = "Oops"
    override val noImage = "No\nimage"

    // ===== Login =====
    override val appTitle = "Boardgame Timer"
    override val loginSubtitle = "Sign in to access your games, players and matches."
    override val labelUsername = "Username"
    override val labelPassword = "Password"
    override val hidePassword = "Hide password"
    override val showPassword = "Show password"
    override val loggingIn = "Signing in..."
    override val login = "Sign In"
    override val forgotPassword = "Forgot password?"
    override val noAccountCreateNow = "Don't have an account? Create now"

    // ===== Signup =====
    override val signupTitle = "Create Account"
    override val signupSubtitle = "Create a clan to save your games, players and matches."
    override val labelClanName = "Clan Name"
    override val labelEmailOptional = "Email (optional)"
    override val labelSenha = "Password"
    override val labelConfirmPassword = "Confirm Password"
    override val creating = "Creating..."
    override val createAccount = "Create Account"
    override val hasAccountLogin = "Already have an account? Sign in"

    // ===== Forgot Password =====
    override val forgotPasswordTitle = "Recover Password"
    override val forgotPasswordInstructions = "Enter the email registered in your account. We will send a 6-digit code so you can create a new password."
    override val forgotPasswordSuccess = "If this email is registered, a 6-digit code was sent. Check your inbox (or spam)."
    override val enterCode = "Enter code"
    override val labelEmail = "Email"
    override val sending = "Sending..."
    override val sendInstructions = "Send Instructions"
    override val backToLogin = "Back to login"

    // ===== Reset Password =====
    override val resetPasswordTitle = "Reset Password"
    override val resetPasswordInstructions = "Enter the email, the 6-digit code received and your new password."
    override val label6DigitCode = "6-digit Code"
    override val placeholderCode = "000000"
    override val labelNewPassword = "New Password"
    override val labelConfirmNewPassword = "Confirm New Password"
    override val resetting = "Resetting..."
    override val resetPassword = "Reset Password"

    // ===== Home Bottom Bar =====
    override val navGames = "Games"
    override val navPlayers = "Players"
    override val navMatches = "Matches"
    override val navMenu = "Menu"
    override val menuClan = "Clan"
    override val menuStats = "Statistics"
    override val menuExpansions = "Expansions"
    override val menuOptions = "Options"

    // ===== Options =====
    override val optionsTitle = "Options"
    override val connectionsTitle = "Connections"
    override val connectSpotify = "Connect to Spotify"
    override val termsTitle = "Terms"
    override val termsOfUseSoon = "Terms of Use"
    override val privacyPolicySoon = "Privacy Policy"
    override val languageTitle = "Language"
    override val themeTitle = "Theme"
    override val themeDefault = "Default"
    override val themeShadow = "Shadow"
    override val themeDefaultDescription = "Bright medieval look with parchment, sand and stone."
    override val themeShadowDescription = "Dark night look with shadow, clouds and dust."
    override val securityTitle = "Security"
    override val changePasswordSoon = "Change Password"
    override val securityDescription = "Change your access password."

    // ===== Dashboard =====
    override val dashboardMonthSummary = "Month Summary"
    override val dashboardMatches = "Matches"
    override val dashboardMinutes = "Minutes"
    override val dashboardTopPlayers = "Top Players"
    override val dashboardMostPlayed = "Most Played"
    override val dashboardLastMatches = "Last Matches"
    override val noDataYet = "No data yet."
    override val noMatchesYet = "No matches recorded yet."
    override val placeholderImg = "IMG"
    override val errorLoading = "Error loading"
    override fun winsFormat(wins: Int) = "Wins: $wins"
    override fun winrateFormat(winrate: Int) = "Winrate: $winrate%"
    override fun matchesCountFormat(count: Int) = "Matches: $count"

    // ===== Games =====
    override val addGame = "Add Game"
    override val noGamesYet = "No games registered yet"
    override val searchGame = "Search game..."
    override val sortAlphabetical = "A–Z"
    override val sortMostPlayed = "Most Played"
    override val filtersTitle = "Filters"
    override val applyFilters = "Apply Filters"
    override val clearFilters = "Clear Filters"
    override val labelCategory = "Category"
    override val labelMode = "Mode"
    override val labelPlayerCount = "Number of Players"
    override fun noGamesFoundFor(query: String) = "No games found for \"$query\""
    override fun filterCategoryFormat(value: String) = "Category: $value"
    override fun filterModeFormat(value: String) = "Mode: $value"
    override fun filterPlayersFormat(value: String) = "Players: $value"
    override fun gamePlayersRange(min: String, max: String) = "Players: $min–$max"
    override fun gameDurationFormat(duration: String) = "Duration: $duration min"
    override fun gameMatchesPlayedFormat(count: Int) = "Matches played: $count"
    override fun gameCategoryFormat(category: String) = "Category: $category"

    // ===== Create/Edit Game =====
    override val createGameTitle = "Add Game"
    override val editGameTitle = "Edit Game"
    override val labelGameName = "Game Name"
    override val sectionGameImage = "Game Image"
    override val selectImage = "Select Image"
    override val escolherFonteImagem = "Choose photo"
    override val camera = "Camera"
    override val galeria = "Gallery"
    override val previewImage = "Image Preview"
    override val currentImage = "Current Image"
    override val labelMinPlayers = "Min Players"
    override val labelMaxPlayers = "Max Players"
    override val labelDurationMin = "Duration (min)"
    override val labelBggUrl = "BGG URL"
    override val labelManualUrl = "Manual URL"
    override val labelSpotifyUrl = "Spotify Playlist"
    override val spotifyUrlHint = "Paste the link shared from Spotify (e.g. open.spotify.com/playlist/...)"
    override val sectionGameOwners = "Game Owners"
    override val loadingPlayers = "Loading players..."
    override val labelAddOwner = "Add Owner"
    override val saveGame = "Save Game"
    override val saveChanges = "Save Changes"
    override val labelCatalogGame = "Catalog game"
    override val pickCatalogGame = "Search catalog"
    override val catalogSearchTitle = "Search catalog"
    override val catalogSearchHint = "Type game name"
    override val catalogSearchTypePrompt = "Type to search"
    override val catalogSearchNoResults = "No games found"
    override val selectCatalogFirst = "Please pick a catalog game"

    // ===== Game Detail =====
    override val gameDetailTitle = "Game Details"
    override val editGame = "Edit Game"
    override val deleteGame = "Delete Game"
    override val deleteGameConfirm = "Are you sure you want to delete this game?"
    override val labelPlayers = "Players"
    override val labelAvgDuration = "Average Duration"
    override val createExpansionBtn = "Create Expansion"
    override val sectionStatistics = "Statistics"
    override val statMatches = "Matches"
    override val statThisYear = "This Year"
    override val statLastMatch = "Last Match"
    override val statFirstMatch = "First Match"
    override val statAverageMatchDuration = "Average Match Duration"
    override val statLongestMatch = "Longest Match"
    override val statShortestMatch = "Shortest Match"
    override val sectionScoreStats = "Score"
    override val statHighestScore = "Highest Score"
    override val statWinnerAverageScore = "Winner Average Score"
    override val statLowestScore = "Lowest Score"
    override val statScorePlayers = "Player(s)"
    override val sectionGameWinners = "Winners"
    override val emptyGameWinners = "There are no wins recorded for this game yet."
    override val sectionOwners = "Owners"
    override val emptyOwners = "No owners registered for this game."
    override val sectionMatchHistory = "Match History"
    override val emptyMatchHistory = "There are no matches recorded for this game yet."
    override fun gameWinnerWinsFormat(wins: Int) = "$wins wins"
    override fun matchDurationDisplay(duration: String) = "Duration: $duration"
    override fun expansionCountFormat(count: Int) = "$count expansion(s)"
    override fun pointsFormat(points: Int) = "$points pts"

    // ===== Players =====
    override val addPlayer = "Add Player"
    override fun playersTitleFormat(count: Int) = "Players ($count)"
    override val searchPlayer = "Search player..."
    override val sortPlayersAZ = "A-Z"
    override val sortPlayersZA = "Z-A"
    override val filterWithNickname = "With nickname"
    override val filterWithoutNickname = "Without nickname"
    override val filterWithPhoto = "With photo"

    // ===== Create/Edit Player =====
    override val createPlayerTitle = "Add Player"
    override val editPlayerTitle = "Edit Player"
    override val labelName = "Name"
    override val labelNicknameOptional = "Nickname (optional)"
    override val sectionPhotoAvatar = "Photo / Avatar"
    override val previewAvatar = "Avatar Preview"
    override val labelBirthdayOptional = "Date of Birth (optional)"
    override val labelPhoneOptional = "Phone (optional)"
    override val savePlayer = "Save Player"

    // ===== Player Detail =====
    override val playerDetailTitle = "Player Details"
    override val deletePlayer = "Delete Player"
    override val deletePlayerConfirm = "Are you sure you want to delete this player?"
    override val labelNickname = "Nickname"
    override val labelBirthday = "Date of Birth"
    override val labelPhone = "Phone"
    override val sectionPlayerStatistics = "Statistics"
    override val sectionWinsByGame = "Won games"
    override val sectionGamesOwned = "Owned games"
    override val sectionRecentMatches = "Recent matches"
    override val sectionMatchups = "Matchups"
    override val matchupPeriodTotal = "All time"
    override val matchupPeriodCurrentYear = "Current year"
    override val matchupTopRivals = "Top 5 rivals"
    override val emptyWinsByGame = "This player has no wins grouped by game yet."
    override val emptyGamesOwned = "This player has no owned games."
    override val emptyRecentMatches = "This player has not played any matches yet."
    override val emptyMatchups = "Not enough matchup history for this period."
    override val matchupMostDefeated = "Most defeated"
    override val matchupMostLostTo = "Most lost to"
    override val matchupMostPlayedTogether = "Most played with"
    override val matchupBestGame = "Best game for you"
    override val matchupWorstGame = "Worst game for you"
    override val playerStatWins = "Wins"
    override val playerStatParticipations = "Participations"
    override val playerStatHoursPlayed = "Hours played"
    override val playerStatWinsYear = "Wins this year"
    override val playerStatParticipationsYear = "Participations this year"
    override val playerStatHoursPlayedYear = "Hours played this year"
    override fun playerGameWinsFormat(wins: Int) = "$wins wins"
    override fun matchupRecordFormat(wins: Int, losses: Int) = "Your record: $wins wins / $losses losses"
    override fun matchupWinRateFormat(pct: Int) = "Your win rate: $pct%"
    override fun matchupDominanceFormat(value: Int) = "Your balance (W-L): ${if (value > 0) "+" else ""}$value"
    override fun matchupLastMatchFormat(date: String) = "Last match: $date"
    override fun matchupBestGameFormat(gameName: String) = "Best game for you: $gameName"
    override fun matchupWorstGameFormat(gameName: String) = "Worst game for you: $gameName"

    // ===== Matches =====
    override val matchesTitle = "Matches"
    override val searchMatch = "Search match..."
    override val matchFiltersTitle = "Match filters"
    override val matchSortDateDesc = "Newest first"
    override val matchSortDateAsc = "Oldest first"
    override val matchSortDurationDesc = "Longest duration"
    override val matchSortDurationAsc = "Shortest duration"
    override val matchFilterGames = "Games"
    override val matchFilterPlayers = "Players"
    override val matchFilterDuration = "Duration"
    override val matchFilterDate = "Date"
    override val matchFilterMinDuration = "Min duration (min)"
    override val matchFilterMaxDuration = "Max duration (min)"
    override val matchFilterStartDate = "Start date"
    override val matchFilterEndDate = "End date"
    override val matchDatePlaceholder = "dd/MM/yyyy"
    override val matchFilterDurationRangeInvalid = "Minimum duration cannot be greater than maximum."
    override val matchFilterDateRangeInvalid = "Start date cannot be greater than end date."
    override fun matchFilterGameFormat(gameName: String) = "Game: $gameName"
    override fun matchFilterPlayerFormat(playerName: String) = "Player: $playerName"
    override fun matchFilterDurationRangeFormat(min: String, max: String) = "Duration: $min-$max min"
    override fun matchFilterDateRangeFormat(start: String, end: String) = "Date: $start - $end"

    // ===== Match Detail =====
    override val matchDetailTitle = "Match Details"
    override val editMatch = "Edit Match"
    override val sectionExpansions = "Expansions"
    override val loadingExpansions = "Loading expansions..."
    override val noExpansionsFound = "No expansions found"
    override val sectionPlayers = "Players"
    override val winner = "Winner"
    override val deleteMatch = "Delete Match"
    override val deleteMatchConfirm = "Are you sure you want to delete this match? This action cannot be undone."
    override fun positionFormat(position: Int) = "${position}th"

    // ===== Match Edit =====
    override val editMatchTitle = "Edit Match"
    override val sectionMatch = "Match"
    override val labelDate = "Date"
    override val labelTimeHHmm = "Time (HH:mm)"
    override val labelObservation = "Observation"
    override val addPlayerBtn = "Add Player"
    override val removePlayer = "Remove Player"
    override val noExpansionsForGame = "This game has no expansions"
    override val dialogAddPlayer = "Add Player"
    override val labelGame = "Game"

    // ===== Start Match Setup =====
    override val startMatchSetupTitle = "Configure Match"
    override val sectionGame = "Game"
    override val noPlayersFound = "No players found."
    override val sectionExpansionsOptional = "Expansions (optional)"
    override val noExpansionsRegistered = "This game has no registered expansions."
    override val startMatch = "Start Match"
    override val errorViewModelCreation = "Failed to create StartMatchSetupViewModel. See console."

    // ===== Active Match =====
    override val activeMatchTitle = "Active Match"
    override val matchInProgress = "Match in Progress"
    override val noActiveMatch = "No active match at the moment."
    override val pause = "Pause"
    override val endMatch = "End Match"
    override val statusPaused = "PAUSED"
    override val resume = "Resume"
    override val cancelMatch = "Cancel Match"
    override val matchFinished = "Match finished!"
    override val firstPlayer = "First Player"
    override val positionFirst = "1st"
    override val none = "None"
    override val sectionCurrentGameStats = "Stats for this game"
    override val bestScoreForGame = "Best score"
    override val averageScoreForGame = "Average score"
    override val worstWinningScoreForGame = "Lowest winning score"
    override val topWinnerForGame = "Most wins"
    override fun winsForPlayerFormat(wins: Int) = "$wins wins"
    override val noStatsForGameYet = "Not enough history for this game yet."
    override val avgDurationForGame = "Average time"
    override val minDurationForGame = "Shortest game"
    override val maxDurationForGame = "Longest game"

    // ===== Match Score =====
    override val scoreTitle = "Score"
    override val sectionPlayerScores = "Score by Player"
    override val labelPts = "Pts"
    override val labelObservationOptional = "Observation (optional)"
    override val required = "Required"
    override val invalid = "Invalid"
    override val saveMatch = "Save Match"
    override val snackbarMatchSaved = "Match saved!"
    override val snackbarErrorSavingMatch = "Error saving match"
    override fun invalidScoreFor(playerName: String) = "Invalid score for: $playerName"
    override fun matchDateDisplay(date: String) = "Date: $date"
    override fun matchDurationMinFormat(minutes: Long) = "Duration: $minutes min"

    // ===== Active Match Summary =====
    override val matchSummaryTitle = "Match Summary"
    override val matchEncerrada = "Match finished!"
    override val conclude = "Conclude"
    override val noFinishedMatch = "No finished match to show."
    override fun matchGameFormat(gameName: String) = "Game: $gameName"
    override fun matchElapsedFormat(elapsed: String) = "Duration: $elapsed"

    // ===== Expansions =====
    override val expansionsTitle = "Expansions"
    override val createExpansionTitle = "Create Expansion"
    override val editExpansionTitle = "Edit Expansion"
    override val labelExpansionName = "Expansion Name"
    override val sectionExpansionImage = "Expansion Image"
    override val previewExpansionImage = "Expansion Image Preview"
    override val labelBggUrlOptional = "BGG URL (optional)"
    override val saveExpansion = "Save Expansion"
    override val selectGame = "Select a game"
    override val labelImageUrlOptional = "Image URL (optional)"
    override fun errorFormat(error: String) = "Error: $error"
    override val bgg = "BGG"
    override val questionMark = "?"

    // ===== Stats =====
    override val statsTitle = "Statistics"
    override val tabGlobal = "Global"
    override val tabYear = "Year"
    override val tabDuration = "Duration"
    override val totalTimePlayed = "Total Time Played"
    override val sectionMostPlayedGames = "Most Played Games"
    override val sectionRankingWinrate = "Ranking (winrate)"
    override val loadingYearHistory = "Loading year history..."
    override val statTimePlayedLabel = "Time Played"
    override val mostPlayedYear = "Most Played This Year"
    override val winsYear = "Wins This Year"
    override val matchesPerMonth = "Matches per Month"
    override val durationPerGame = "Duration per Game"
    override val loadingDurationStats = "Loading duration per game..."
    override fun rankingWinrateFormat(pct: Int, wins: Int) = "$pct% • ${wins}W"
    override fun participationsFormat(count: Int) = "Participations: $count"
    override fun previousYearFormat(year: Int) = "← $year"
    override fun nextYearFormat(year: Int) = "$year →"
    override fun gameDurationStatsFormat(count: Int, avg: Int, min: Int, max: Int) =
        "Matches: $count • Average: $avg min • Min: $min • Max: $max"
    override fun monthLabel(month: Int) = "Month $month"
    override fun countFormat(count: Int) = "${count}x"
    override fun winratePercentFormat(pct: Int) = "$pct%"
    override fun winsCountFormat(wins: Int) = "${wins}W"
    override val monthsAbbreviations = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
    override val sectionSummary = "Summary"
    override val sectionCategoriesMostPlayed = "Most Played Categories"
    override val sectionPlayerMinutes = "Time by Player"
    override val sectionParticipations = "Participations"
    override val uniqueGamesLabel = "different games"
    override fun minutesFormat(minutes: Int): String {
        val h = minutes / 60
        val m = minutes % 60
        return if (h > 0) "${h}h ${m}min" else "${m}min"
    }
    override fun participationsCountFormat(count: Int) = "$count matches"

    // ===== Clan =====
    override val clanTitle = "Clan"
    override val saving = "Saving..."

    // ===== Dialogs =====
    override val dialogFinishMatch = "Finish Match"
    override val dialogFinishMatchConfirm = "Are you sure you want to finish the active match?"
    override val finish = "Finish"
    override val dialogActiveMatchInProgress = "Active Match in Progress"
    override val dialogActiveMatchChoice = "You already have an active match. What do you want to do?"
    override val continueCurrent = "Continue Current"
    override val replace = "Replace"

    // ===== Active Match Mini Player =====
    override val statusRunning = "Running"
    override val statusFinished = "Finished"
    override val activeMatchFallback = "Active Match"
    override fun matchTimeStatusFormat(time: String, status: String) = "Time: $time • $status"
    override val openMatch = "Open Match"
    override val finishMatch = "Finish Match"

    // ===== ViewModel Error Messages =====
    override val usernameRequired = "Username is required"
    override val passwordRequired = "Password is required"
    override val usernameCannotBeEmpty = "Username cannot be empty"
    override val clanNameRequired = "Clan name is required"
    override val clanNameCannotBeEmpty = "Clan name cannot be empty"
    override val passwordsDoNotMatch = "Passwords do not match"
    override val emailRequired = "Email is required"
    override val invalidOrExpiredCode = "Invalid or expired code"
    override val codeMustBe6Digits = "Code must be 6 digits"
    override val newPasswordRequired = "New password is required"
    override val newPasswordMustBeDifferent = "New password must be different from current password"
    override val errorLoadingGames = "Error loading games"
    override val errorCreatingGame = "Error creating game"
    override val errorSavingGame = "Error saving"
    override val errorDeletingGame = "Could not delete the game."
    override val unknownError = "Unknown error"
    override val errorLoadingPlayers = "Error loading players"
    override val errorCreatingPlayer = "Error creating player"
    override val errorSavingPlayer = "Error saving player"
    override val errorDeletingPlayer = "Could not delete the player."
    override val errorLoadingMatchDetails = "Error loading match details"
    override val errorSavingMatch = "Error saving match"
    override val errorCreatingExpansion = "Error creating expansion"
    override val errorUpdatingExpansion = "Error updating expansion"
    override val errorLoadingExpansion = "Error loading expansion"
    override val errorLoadingExpansions = "Error loading expansions"
    override val expansionCreatedSuccess = "Expansion created successfully!"
    override val expansionUpdatedSuccess = "Expansion updated successfully!"
    override val errorLoadingStats = "Error loading statistics"
    override val errorLoadingDurationStats = "Error loading duration per game"
    override val errorLoadingYearHistory = "Error loading year history"
    override val errorLoadingClan = "Error loading clan"
    override val errorLoadingOwners = "Error loading owners"
    override val errorUploadingImage = "Failed to upload image"
    override val gameNameRequired = "Name is required"
    override val categoryAndModeRequired = "Category and mode are required"
    override val selectAtLeastOneOwner = "Select at least one owner"
    override val minCannotBeGreaterThanMax = "Min cannot be greater than Max"
    override val expansionNameRequired = "Expansion name is required"
    override val invalidDateFormat = "Invalid date. Use dd/MM/yyyy"
    override val invalidBirthday = "Invalid date of birth"
    override val playerNameRequired = "Name is required"
    override val selectAGame = "Select a game"
    override val selectAtLeastOnePlayer = "Select at least 1 player"
    override val invalidPlayersAndScores = "Provide valid players and scores"
    override val errorDeletingMatch = "Could not delete the match."
    override val matchDeletedSuccess = "Match deleted successfully!"
    override val playerCreatedSuccess = "Player created successfully"
    override val errorSavingClan = "Error saving"
    override val passwordChangedSuccess = "Password changed successfully"
    override val spotifyDeviceTitle = "Spotify Device"
    override val spotifyRefresh = "Refresh"
    override val spotifyNoDevices = "No devices found. Open Spotify on a device (phone/PC) and try refreshing."
    override val spotifyDeviceActive = " • Active now ✅"
    override val spotifyDeviceRestricted = " • Restricted ⚠️"
    override val spotifyDoNotPlay = "Do not play music"
    override val spotifyReconnectRequired = "Your Spotify connection expired. Reconnect in Options > Connections."
    override val spotifyOnlyInApp = "Feature available only in the app (Android/iOS)."
    override val durationLabel = "Duration"
    override fun durationMinutesFormat(min: Int) = "$min min"
}
